
import { Injectable } from '@angular/core';
import { ADD_NOTIFICATION, REMOVE_NOTIFICATION, addNotificationSuccess, removeNotificationSuccess } from '@core/store/actions/notifications.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';

@Injectable()
export class NotificationsEffects {

  constructor(private actions: Actions) { }

  addNotification = createEffect(() => {
    return this.actions.pipe(
      ofType(ADD_NOTIFICATION),
      map(notification => addNotificationSuccess({ payload: notification }))
    )
  });

  removeNotification = createEffect(() => {
    return this.actions.pipe(
      ofType(REMOVE_NOTIFICATION),
      map(notification => removeNotificationSuccess({ payload: notification }))
    )
  });

}
